import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';
import { AccountItem, TypeaheadService } from '../../../services/typeahead.service';

@Component({
  selector: 'tt-travel-wage',
  templateUrl: './travel-wage.component.html',
  styleUrls: ['./travel-wage.component.css']
})
export class TravelWageComponent implements OnInit {
    public travelWageId: string;

    public edit?: Edit;

    public selectListTravelWageTypes: Item[] = [];

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService, private typeahead: TypeaheadService) {
        this.travelWageId = this.stateService.getStateParams()['travelwage_id'];
    }

    private async loadEdit() {
        if (!!this.travelWageId) {
            this.edit = (await this.datatask.Post(1489, { travelwage_id: this.travelWageId }))[0];
        }
    }

    private async loadTravelWageTypes() {
        this.selectListTravelWageTypes = await this.datatask.Post(1490);
    }

    public searchAccountNames = () => {
        return this.typeahead.lookUpSearchAccounts({
            searchtext: this.edit!.account_name,
            businessco_no: this.edit!.businessco_no
        });
    }

    public onAccountNameSelected(event?: AccountItem) {
        if (!this.edit) return;

        this.edit.account_no = !!event ? '' + event.item_id : '0';
        this.edit.account_name = event?.item_name ?? '';
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(1492, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
        this.loadTravelWageTypes();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    travelwage_id: string;
    travelwage_name: string;
    travelwagetype_id: string;
    isnew: string;
    account_no: string;
    account_name: string;
    businessco_no: string;
}
